"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
exports.error = function (msg) {
    throw new Error(msg);
};
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pdf-lib/cjs/utils/errors.js
// module id = 720
// module chunks = 0